export const oneRYesDomi = "🏠 1 #room 🟢 Domiciliation: #yes";
export const oneRNoDomi = "🏠 1 #room 🔴 Domiciliation: #no";
export const oneRUnDomi = "🏠 1 #room ⚪ Domiciliation: #unknown";
export const oneStYesDomi = "🏠 #Studio 🟢 Domiciliation: yes";
export const oneStNoDomi = "🏠 #Studio 🔴 Domiciliation: #no";
export const oneStUnDomi = "🏠 #Studio ⚪Domiciliation: #unknown";
export const twoRYesDomi = "🏠 2 #rooms_apartment  🟢 Domiciliation: #yes";
export const twoRNoDomi = "🏠 2 #rooms_apartment  🔴 Domiciliation: #no";
export const twoRUnDomi = "🏠 2 #rooms_apartment  ⚪ Domiciliation: #unknown";
export const none = "";
